import React, { useMemo } from "react";
import { useSelector } from "react-redux";
import { RootState } from "app/lib/store/store";
import Layout from "app/components/layouts";
import PartOne from "app/components/Individual/employmentDetails/PartOne";
import PartTwo from "app/components/Individual/employmentDetails/PartTwo";
import PreviousEmployer from "app/components/Individual/employmentDetails/PreviousEmployer";
import SecondEmployment from "app/components/Individual/employmentDetails/SecondEmployment";

import LoanTypeStepper from "app/components/common/LoanTypeStepper";

const EmploymentDetails: React.FC = () => {
  const currentStep = useSelector(
    (state: RootState) => state.employmentDetails.currentStep
  );
  const employmentData = useSelector(
    (state: RootState) => state.employmentDetails
  );
  const adjustedStep =
    employmentData?.stepsData?.formTwo?.hassecondjob === "yes" &&
    currentStep === 3
      ? 4
      : currentStep;

  const steps: JSX.Element[] = [
    <PartOne key="employer-part-One" />,
    <PartTwo key="employer-part-two" />,
    <PreviousEmployer key="previous-employer" />,
    <SecondEmployment key="second-employer" />,
  ];

  const renderStep = useMemo(
    () => steps[(adjustedStep ?? 1) - 1] ?? <PartOne />,
    [adjustedStep]
  );
  return (
    <>
      <Layout>
        <LoanTypeStepper />
        {renderStep}
      </Layout>
    </>
  );
};

export default EmploymentDetails;
